export interface PurchaseOrderValidationResponse {
  purchaseOrderCode: string;
  isValid: boolean;
}
